// Fetch Payroll Stop Payment
export const FETCH_PAYROLL_STOP_PAYMENT_REQUEST = 'FETCH_PAYROLL_STOP_PAYMENT_REQUEST';
export const FETCH_PAYROLL_STOP_PAYMENT_SUCCESS = 'FETCH_PAYROLL_STOP_PAYMENT_SUCCESS';
export const FETCH_PAYROLL_STOP_PAYMENT_FAILURE = 'FETCH_PAYROLL_STOP_PAYMENT_FAILURE';

// Save Payroll Stop Payment
export const SAVE_PAYROLL_STOP_PAYMENT_REQUEST = 'SAVE_PAYROLL_STOP_PAYMENT_REQUEST';
export const SAVE_PAYROLL_STOP_PAYMENT_SUCCESS = 'SAVE_PAYROLL_STOP_PAYMENT_SUCCESS';
export const SAVE_PAYROLL_STOP_PAYMENT_FAILURE = 'SAVE_PAYROLL_STOP_PAYMENT_FAILURE';

export const SAVE_REOPEN_PAYMENT = "SAVE_REOPEN_PAYMENT";
export const SAVE_REOPEN_PAYMENT_SUCCESS = "SAVE_REOPEN_PAYMENT_SUCCESS";
export const SAVE_REOPEN_PAYMENT_FAILURE = "SAVE_REOPEN_PAYMENT_FAILURE"